module.exports = "pegasus_template/assets/test-fixture-cat.png";